import "sanitize.css";

import "./index.scss";

import "elements/scripts";
import "components/scripts";

import { loggerService, lazyLoadService } from "services";
import { openMenu } from "components/header";

loggerService.log({
  icon: "👾",
  title: "Test",
  body: "Test",
});

// init lazy load script
lazyLoadService.observe();

// used on 403/404 pages to open the menu from a text link
(() => {
  const menuOpenLinks = document.querySelectorAll<HTMLButtonElement>(
    "[data-menu-open-link]"
  );

  menuOpenLinks.forEach((link) => {
    link.addEventListener("click", () => {
      openMenu();
    });
  });
})();
